import {
  GridColDef,
  GridInitialState,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import { I18nGrid } from "@/components/data/I18nGrid";
import { ExportToolbar } from "@/components/grid/ExportToolbar";
import { Report } from "@/utilities/export/report";

const PAGE_SIZE_OPTIONS = [25, 50, 100, 500];

interface Props<TRow extends GridValidRowModel> {
  /** Preamble of the Excel export; the table itself is read from the grid. */
  report: Omit<Report, "table">;
  /** Decimals of the numeric columns in Excel, by column field. */
  fractionDigits: Record<string, number>;
  rows: TRow[];
  columns: GridColDef<TRow>[];
  loading: boolean;
  initialState?: GridInitialState;
  /** Disables the export while the figures are still arriving. */
  exportDisabled?: boolean;
  /** Names the view whose column layout and row height are remembered per user. */
  settingsKey: string;
}

/**
 * The grid all three views of the report share.
 *
 * One component rather than three near-identical ones, so a column setting, an export option or a
 * page size is changed in one place and the three views cannot drift apart.
 */
export function EnergyReportGrid<TRow extends GridValidRowModel>({
  rows,
  columns,
  loading,
  report,
  fractionDigits,
  initialState,
  exportDisabled,
  settingsKey,
}: Props<TRow>) {
  return (
    <I18nGrid
      rows={rows}
      columns={columns}
      loading={loading}
      disableRowSelectionOnClick
      pagination
      pageSizeOptions={PAGE_SIZE_OPTIONS}
      settingsKey={settingsKey}
      initialState={{
        pagination: { paginationModel: { pageSize: 100 } },
        ...initialState,
      }}
      slots={{ toolbar: ExportToolbar }}
      slotProps={{ toolbar: { report, fractionDigits, exportDisabled } }}
      sx={{ border: 0 }}
    />
  );
}
